import { ThemeComponentType } from '../types';

export const Alert: ThemeComponentType = {
  styles: (theme, { color, variant }) => ({
    root: {
      // borderColor: color ? theme.colors[color][2] : theme.colors.gray[2],
      padding: theme.other.spacing(1.5),
      backgroundColor: color ? theme.colors[color][1] : theme.colors.gray[1],
    },
    wrapper: {
      alignItems: 'center',
    },
    label: {
      color: theme.black,
      fontSize: theme.fontSizes.md,
      marginTop: -2,
    },
    message: {
      fontSize: theme.fontSizes.md,
    },
    icon: {
      marginRight: theme.other.spacing(1),
      width: 'fit-content',
      height: 'fit-content',
    },
  }),
};
